import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../theming/useTheme';

const componentConfigThemeKey = 'cardOverlay';


export const hex2rgba = (hex:string, alpha = 1) => {
  // @ts-ignore
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};


const CardOverlayStyles = (cardOverlayColor: string) => {
  return StyleSheet.create({
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      bottom: '0px',
      background: `linear-gradient(0deg, ${hex2rgba(cardOverlayColor, 0.7)} 0%, rgba(0,0,0,0) 50%)`,
    },
  });
};

interface CardOverlayComponentDataProps { }

interface CardOverlayComponentThemeProps {
  cardOverlayColor: string
}

type Props = CardOverlayComponentDataProps & CardOverlayComponentThemeProps;

class CardOverlayComponent extends React.Component<Props> {
  render() {
    const { cardOverlayColor } = this.props;
    const cardOverlayStyle = CardOverlayStyles(cardOverlayColor);
    return (
      <div className={css(cardOverlayStyle.style)} />
    );
  }
}

const mapThemeProps = (theme: CardOverlayComponentThemeProps): CardOverlayComponentThemeProps => (
  {
    cardOverlayColor: theme.cardOverlayColor,
  }
);

export const CardOverlay = (props: CardOverlayComponentDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <CardOverlayComponent {...themeContext} {...props} />;
};
